export const CHART_COLORS_DARK_MODE = [
  '#7C4DFF',
  '#F97D56',
  '#DD7AFF',
  '#FBE054',
  '#34C0FF',

  '#F7588D',
  '#60DB91',
  '#BFC2FF',
  '#E25428',
  '#31DDDD',

  '#C19703',
  '#FBB4AF',
  '#2962FF',
  '#B86161',
  '#87C845',
];

export const CHART_COLORS_LIGHT_MODE = [
  '#4993F5',
  '#48A741',
  '#EA629B',
  '#C4870E',
  '#EE6640',

  '#949480',
  '#C670D4',
  '#496DCA',
  '#1BA785',
  '#A45E2C',

  '#937DF6',
  '#D94343',
  '#979931',
  '#D47777',
  '#519CBD',
];

export const HAS_CATEGORY = '_HAS_CATEGORY_';
